var map = {
	"./10-11.mp3": 1756,
	"./106-107.mp3": 3332,
	"./108-109.mp3": 6640,
	"./110-111.mp3": 5172,
	"./114-115.mp3": 860,
	"./118-119.mp3": 1700,
	"./12-13.mp3": 7616,
	"./122-123.mp3": 5456,
	"./14-15.mp3": 7692,
	"./16-17.mp3": 7880,
	"./20-21.mp3": 9970,
	"./22-23.mp3": 990,
	"./24-25.mp3": 1850,
	"./32-33.mp3": 687,
	"./38-39.mp3": 5280,
	"./48-49.mp3": 9762,
	"./50-51.mp3": 2812,
	"./52-53.mp3": 632,
	"./54-55.mp3": 2012,
	"./56-57.mp3": 5840,
	"./58-59.mp3": 5660,
	"./6-7.mp3": 2520,
	"./60-61.mp3": 7434,
	"./72-73.mp3": 5676,
	"./8-9.mp3": 4756,
	"./80-81.mp3": 1194,
	"./86-87.mp3": 6838,
	"./92-93.mp3": 2432,
	"./94-95.mp3": 812,
	"./96-96.mp3": 1197,
	"./98-99.mp3": 7260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2234;